<template>
  <FormBlock>
    <AppRow sequence-two>
      <PassportNameField v-model="passport.lastName" type="last" />
      <PassportNameField v-model="passport.firstName" type="first" />
      <PassportNumber
        v-if="'number' in passport"
        v-model="passport.number"
      />
      <NationalitySelect
        v-if="'nationality' in passport"
        v-model="passport.nationality"
        :countries="nationalities"
      />
      <DateOfBirth
        v-if="'dateOfBirth' in passport"
        v-model="passport.dateOfBirth"
      />
      <BirthCountrySelect
        v-if="'countryOfBirth' in passport"
        v-model="passport.countryOfBirth"
      />
      <DateOfIssue
        v-if="'dateOfIssue' in passport"
        v-model="passport.dateOfIssue"
      />
      <DateOfExpiry
        v-if="'dateOfExpiry' in passport"
        v-model="passport.dateOfExpiry"
      />
      <SexSelect
        v-if="'sex' in passport"
        v-model="passport.sex"
      />
      <CountrySelect
        v-if="'placeOfIssue' in passport"
        v-model="passport.placeOfIssue"
        :label="$tt('passport_issue_place')"
        :hint="$tt('authority')"
      />
    </AppRow>
  </FormBlock>
</template>

<script setup lang="ts">
import { countryKeyInjectionKey } from '~/assets/injection-keys';
import getEligibleNationalities from '~/helpers/eligibility';
import type { Applicant } from '~/types';

const country = inject(countryKeyInjectionKey)!;
const passport = defineModel<Applicant['passport']>({ required: true });

const nationalities =
  useBranch().visaCountryNationalities?.[country] ||
  await getEligibleNationalities(country).catch(() => undefined);
</script>